import CreatorProfile from "./CreatorProfile";

export default function AVTheEntertainerProfile() {
  return (
    <CreatorProfile
      creatorId={11}
      categoryLabel="Glamour Realism"
      onlyMemberzSlug="avtheentertainer"
      tags={["Glamour", "Photo-Shoot", "BTS", "Illusionistz"]}
    />
  );
}
